import { SUPPORTED_LANGUAGES } from 'common/constant/constant';
import EventDto from './event-dto';
import TournamentDto from './tournament-dto';
import UserGroupDto from './user-group-dto';
import { EnumOption } from 'common/enum-value';

export enum CalendarStatus {
    Active = 0,
    Archived = 1,
}

export enum EventsLoggingLevel {
    AllChanges = 0,
    PublishedOnly = 1,
    Off = 2,
}

export const EventsLoggingLevelOptions: EnumOption[] = [
    { label: 'All Changes', value: EventsLoggingLevel.AllChanges },
    { label: 'Published Only', value: EventsLoggingLevel.PublishedOnly },
    { label: 'Off', value: EventsLoggingLevel.Off },
];

type CalendarDto = {
    id: number;
    localizedContents?: Partial<Record<SUPPORTED_LANGUAGES, CalendarLocalized>>;
    timeZones: Array<TimeZone>;
    events?: Array<EventDto>;
    sharedEvents?: Array<EventDto>;
    tournament?: TournamentDto | null;
    managementGroups?: Array<UserGroupDto>;
    canShowInSubscription: boolean;
    startDate?: Date | string | null;
    endDate?: Date | string | null;
    status: CalendarStatus;
    loggingLevel: EventsLoggingLevel;
    translateInto?: string | null;
};

type CalendarLocalized = {
    shortName?: string;
    name?: string;
    description?: string;
};

export type TimeZone = {
    ianaIdentifier: string;
};

export default CalendarDto;
